import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
import wujiFetch from '@/utils/wujiFetch';
class AiProjectLoader {
    async getProjectInfo(projectId, env, branchId) {
        const url = `${getXyManagePathPrefix({ envId: env, branchId })}/ai-project/info?projectId=${projectId}`;
        return wujiFetch(url);
    }
}
export default new AiProjectLoader();
